export const SET_DECEASED_DETAILS = 'SET_DECEASED_DETAILS';
export const SEE_DECEASED_DEATH_CERT = 'SEE_DECEASED_DEATH_CERT';

export const setDeceasedDetails = (field, value, isAddress) =>{
  return{
    type: SET_DECEASED_DETAILS,
    field,
    value,
    isAddress,
  }
}

export const setDeceasedDeathCertificate = (payload) =>{
  return{
    type: SEE_DECEASED_DEATH_CERT,
    payload
  }
}
